import {
	MAIN_COLOR,
	SECONDARY_BG_COLOR,
	SHADOW_COLOR,
	TEXT_COLOR,
} from 'shared/consts';
import { getContrastColor } from 'shared/lib/colors';
import styled from 'styled-components';

export const selectStylesOption = (state: any) => {
	return {
		backgroundColor: state.isSelected ? MAIN_COLOR : 'white',
		// color: state.isSelected ? 'white' : TEXT_COLOR,
		borderRadius: '24px',
		padding: '2px',
		'&:hover': {
			backgroundColor: state.isSelected ? MAIN_COLOR : SECONDARY_BG_COLOR,
			cursor: 'pointer',
		  color: state.isSelected ? 'white' : TEXT_COLOR,
		},
		marginBottom: '12px',
    fontSize: '14px',
    border: `2px solid ${state.data.color}`,
    background: state.data.color,
    color: getContrastColor(state.data.color),
	};
};

export const selectStylesControl = (state: any) => {
	return {
		borderRadius: '24px',
		background: '#FFFFFF',
		border: state.isFocused ? `1px solid ${MAIN_COLOR}` : 'none',
		boxShadow: state.isFocused ? `0 0 5px ${SHADOW_COLOR}` : 'none',
    minWidth: '100%',
	};
};

export const selectStyles = {
	control: (provided: any, state: any) => ({
		...provided,
		...selectStylesControl(state),
	}),
	dropdownIndicator: (provided: any) => ({ ...provided, color: MAIN_COLOR }),
	option: (provided: any, state: any) => ({
		...provided,
		...selectStylesOption(state),
	}),
	input: (provided: any) => {
		return {
			...provided,
			textAlign: 'center',
			margin: '0 auto'
		}
	},
	menu: (provided: any, _: any) => ({
		...provided,
		borderRadius: '24px',
		display: 'flex',
		justifyContent: 'center',
		height: '50vh',
		boxShadow: `0 4px 12px ${SHADOW_COLOR}`,
	}),
	menuList: (provided: any, _: any) => ({
		...provided,
		textAlign: 'center',
		width: '70%',
		maxHeight: '500px',
		paddingTop: '12px',
	}),
	indicatorSeparator: (provided: any) => ({
		...provided,
		display: 'none',
	}),
};

export const ArrowContainer = styled.div`
	margin-top: 6px;
	margin-right: 10px;
`;
